import { render, staticRenderFns } from "./QutationTemplate.vue?vue&type=template&id=853e0044&scoped=true&"
import script from "./QutationTemplate.vue?vue&type=script&lang=js&"
export * from "./QutationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./QutationTemplate.vue?vue&type=style&index=0&id=853e0044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853e0044",
  null
  
)

export default component.exports